module.exports = __webpack_public_path__ + "assets/chevron-down-bold-432a58.svg";